import { Link } from 'react-router-dom';

interface CTAButtonProps {
  to: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  icon?: string;
  className?: string;
}

export default function CTAButton({ to, children, variant = 'primary', icon, className = '' }: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-md text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer';
  
  const variantStyles = {
    primary: 'bg-[#C7A86A] text-[#0F0F0F] hover:bg-[#B89858] shadow-[0_2px_8px_rgba(199,168,106,0.15)]',
    secondary: 'bg-transparent border border-[#C7A86A] text-[#C7A86A] hover:bg-[#C7A86A]/10',
  };

  return (
    <Link
      to={to}
      className={`${baseStyles} ${variantStyles[variant]} ${className}`}
    >
      {children}
      {icon && <i className={`${icon} ml-2 text-lg`}></i>}
    </Link>
  );
}
